import { render, staticRenderFns } from "./modelAttr.vue?vue&type=template&id=32b831f8&scoped=true&lang=pug"
import script from "./modelAttr.vue?vue&type=script&lang=js"
export * from "./modelAttr.vue?vue&type=script&lang=js"
import style0 from "@/CommonDP/mongeView/common/common.scss?vue&type=style&index=0&id=32b831f8&prod&lang=scss&scoped=true&external"
import style1 from "./modelAttr.vue?vue&type=style&index=1&id=32b831f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b831f8",
  null
  
)

export default component.exports